import formatFullDate from "components/ProjectSpecificComponents/Functions/formatFullDate"
import { stripHtml } from "string-strip-html"

/**
 * Function to parse UI value, to present it based on field type
 */
const parseValueForType = (value: string | number | undefined | string[], type: string) => {
	if (!value || typeof value !== "string") return value

	switch (type) {
		case "DATE":
			return formatFullDate(value, false)
		case "RICHTEXT":
			value = value.toString()
			return stripHtml(value).result
		default:
			return value
	}
}

export default parseValueForType
